"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../../assets/css/components/structure/header.css");

require("material-design-lite/material.min.css");

require("../../assets/css/calendar.min.css");

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _reactRouter = require("react-router");

var _Tab = require("../elements/Tab");

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import "../../assets/css/semantic.min.css";


var Cabecalho = function (_React$Component) {
    _inherits(Cabecalho, _React$Component);

    function Cabecalho(props) {
        _classCallCheck(this, Cabecalho);

        var _this = _possibleConstructorReturn(this, (Cabecalho.__proto__ || Object.getPrototypeOf(Cabecalho)).call(this, props));

        _this.openApps = function () {
            _this.setState(function (prevState, props) {
                return { appsOpen: !prevState.appsOpen };
            });
        };

        _this.getAplicacoes = function (sistemas) {
            if (sistemas && sistemas.length > 0) return _this.props.sistemas.map(function (s) {
                return _react2.default.createElement(
                    "li",
                    { key: s.sigla },
                    _react2.default.createElement(
                        "a",
                        { href: s.url, target: "_blank", title: s.nome, "aria-label": 'Acessar o sistema ' + s.nome },
                        _react2.default.createElement("i", { "aria-hidden": "true", className: "app-icon icon-" + s.sigla }),
                        _react2.default.createElement(
                            "span",
                            { className: "text" },
                            s.sigla
                        )
                    )
                );
            });
            return null;
        };

        _this.getNav = function () {
            if (_this.props.appMenu) return _react2.default.createElement(
                "nav",
                { className: "header-nav" },
                _react2.default.createElement(
                    "ul",
                    { className: "header-option" },
                    _react2.default.createElement(
                        "li",
                        { className: "header-option" },
                        _react2.default.createElement(
                            "button",
                            { className: "user-app", "aria-haspopup": "true", "aria-label": "Aplica\xE7\xF5es do Usu\xE1rio",
                                "aria-expanded": _this.state.appsOpen, onClick: _this.openApps, onBlur: _this.onBlur },
                            _react2.default.createElement(_Icone2.default, { icone: "apps", tamanho: "1.7" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "apps-list" + (_this.state.appsOpen ? " open-app-list" : "") },
                            _react2.default.createElement(
                                "ul",
                                null,
                                _react2.default.createElement(
                                    "div",
                                    { className: "app-list-content" },
                                    _this.getAplicacoes(_this.props.sistemas)
                                ),
                                _react2.default.createElement(
                                    "li",
                                    { className: "all-apps" },
                                    _react2.default.createElement(
                                        "a",
                                        { href: "#" },
                                        "Todos os sistemas"
                                    )
                                )
                            )
                        )
                    )
                )
            );else return null;
        };

        _this.state = {
            displaySideMenu: false,
            appsOpen: false
        };
        _this.onDisplayMenu = _this.onDisplayMenu.bind(_this);
        _this.openApps = _this.openApps.bind(_this);
        return _this;
    }

    _createClass(Cabecalho, [{
        key: "onDisplayMenu",
        value: function onDisplayMenu() {
            var _this2 = this;

            this.setState(function (prevState, props) {
                if (_this2.props.onDisplayMenu) _this2.props.onDisplayMenu(!prevState.displaySideMenu);
                return { displaySideMenu: !prevState.displaySideMenu };
            });
        }
    }, {
        key: "getMenuIcon",
        value: function getMenuIcon() {
            return _react2.default.createElement(_Icone2.default, { icone: this.state.displaySideMenu ? "clear" : "dehaze" });
        }
    }, {
        key: "getHideContent",
        value: function getHideContent() {
            return this.state.displaySideMenu ? _react2.default.createElement("div", { className: "nav-hide-content", onClick: this.onDisplayMenu, "aria-hidden": "true" }) : "";
        }
    }, {
        key: "getTabs",
        value: function getTabs() {
            if (this.props.tabsOptions) return _react2.default.createElement(_Tab2.default, { options: this.props.tabsOptions });
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "header",
                { "aria-label": "Página atual de " + this.props.titulo, className: "mdl-layout__header primary " + (this.state.displaySideMenu ? "header-nav-opened" : "") + (this.props.tabsOptions ? " tab-header" : "") },
                _react2.default.createElement(
                    "div",
                    { className: "actionbar-menu", "aria-label": "Menu principal", role: "button",
                        onClick: this.onDisplayMenu, tabIndex: 0 },
                    this.getMenuIcon()
                ),
                _react2.default.createElement(
                    "div",
                    { className: "mdl-layout__header-row", "aria-hidden": "true" },
                    _react2.default.createElement(
                        "div",
                        { className: "text-title mdl-layout-spacer",
                            "aria-label": "Página atual de " + this.props.titulo },
                        this.props.titulo
                    ),
                    this.getNav()
                ),
                this.getTabs(),
                this.getHideContent()
            );
        }
    }]);

    return Cabecalho;
}(_react2.default.Component);

exports.default = Cabecalho;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/structure/Header.js
// module id = 595
// module chunks = 0